export enum InnovyzeEntitlement {
	AM_DASHBOARD = 'AMDashboard',
	AM_MAP = 'AMMap',
	AM_INSPECTIONS = 'AMInspections',
	AM_RISK = 'AMRisk',
	AM_GISIMPORT = 'AMGISImport',
}
